module.exports = __webpack_public_path__ + "media/images/linkedin-04e419b047cee444054a1684e4997d49.svg";